import React from 'react';
import { Lock, AlertTriangle } from 'lucide-react';
import { useAccessLock } from '../../hooks/useAccessLock';
import { useSidebar } from '../../../shared/contexts/SidebarContext';

const CONTACT_LINE = 'Please clear the pending payment or contact Housingram to restore access.';

/**
 * Super-admin billing lock notice. "locked" replaces the page with a lock
 * screen; "limited" pins a strip naming the disabled features to the bottom,
 * since every page's header is fixed to the top.
 */
const AccessLockNotice = ({ children }) => {
  const { isLocked, isLimited, groups, message } = useAccessLock();
  const { collapsed } = useSidebar();

  if (isLocked) {
    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="max-w-md rounded-2xl border border-red-100 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
            <Lock className="h-6 w-6 text-red-600" />
          </div>
          <h2 className="mb-2 text-lg font-semibold text-gray-900">Account locked</h2>
          <p className="text-sm text-gray-600">
            {message || 'Your account has been locked due to pending payment.'}
          </p>
          <p className="mt-3 text-sm text-gray-500">{CONTACT_LINE}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {children}
      {isLimited ? (
        <div
          className={`fixed bottom-0 right-0 z-40 flex ${
            collapsed ? 'left-[76px]' : 'left-64'
          } items-start gap-2 border-t border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900`}>
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
          <span>
            {message || 'Some features are disabled due to pending payment.'}{' '}
            {groups.length ? (
              <span className="font-medium">
                Disabled: {groups.map((g) => g.label).join(', ')}.
              </span>
            ) : null}{' '}
            {CONTACT_LINE}
          </span>
        </div>
      ) : null}
    </>
  );
};

export default AccessLockNotice;
